import React, { Component } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { actions } from 'modules/modal';
import { actions as userActions } from 'modules/user';
import Grid from 'material-ui/Grid';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

class Header extends Component {
  restrictedRoute(isAuthenticated, test, Component) {
    return isAuthenticated === test ? Component : null;
  }

  //<Button color="contrast" to="/checkout/offer-1" component={Link}>Checkout Offer-1</Button>*/}
  render() {
    const { firstName, isAuthenticated, openModal, logoutUser, restrictedRoute } = this.props;

    return (
      <Grid item xs={12} md={12}>
        <AppBar position="static">
          <Toolbar>
            <Typography type="title" color="inherit" style={{flex: '1'}}>Food Revolution Network</Typography>
            { this.restrictedRoute(
                isAuthenticated,
                false,
                <Button color="contrast" onClick={() => openModal("login")}>Login</Button>
            )}
            { isAuthenticated ? <Button color="contrast" onClick={() => logoutUser()}>Logout</Button> : null }
            <Button color="secondary" to="/" component={Link}>Blog</Button>
            <Button color="secondary" to="/" component={Link}>About</Button>
            <Button color="secondary" to="/" component={Link}>Contact</Button>
          </Toolbar>
        </AppBar>
      </Grid>
      
    );
  }
  
}

const mapStateToProps = (state, props) => {
  return {
    isAuthenticated: state.user.isAuthenticated,
    firstName: state.user.firstName
  }
}

const mapDispatchToProps = {
  openModal: actions.openModal,
  logoutUser: userActions.logoutUser
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));


// WEBPACK FOOTER //
// ./components/Header/index.jsx